/** RGL convention — single source of truth for renderer + placement logic.
 *  48 (4× RGL's usual 12) → fine horizontal drag/resize snapping. Persisted
 *  layouts rebase to the active count on load (see rescale.ts), so it can
 *  change without corrupting saved dashboards. */
export const GRID_COLS = 48;

// Natural rowHeight on a tall-enough stage; scales DOWN proportionally when
// the viewport can't fit every card at its declared `h` (clamped to
// MIN_ROW_HEIGHT). Drag-resize stays in row units.
export const NATURAL_ROW_HEIGHT = 50;
export const MIN_ROW_HEIGHT = 22;
export const MARGIN: [number, number] = [12, 12];
export const CONTAINER_PADDING: [number, number] = [0, 0];

// Resize floors (grid units) for items that declare none — ~1/8 of GRID_COLS.
// Lowered from 9 → 6 once compact toggles + responsive titles made narrow
// panels usable (a card can now collapse to ~192px on a 1536px board).
export const DEFAULT_MIN_W = 6;
export const DEFAULT_MIN_H = 3;

// Drag handle = panel header; cancel = anything in the tools region.
// react-draggable walks ancestors, so any descendant of `.wb-panel__tools`
// is drag-safe automatically. `.wb-panel__ico`/`.wb-panel__seg` are
// defence-in-depth for tool widgets rendered outside the tools slot.
export const DRAG_HANDLE_SELECTOR = '.wb-panel__head';
export const DRAG_CANCEL_SELECTOR =
  '.wb-panel__tools, .wb-panel__ico, .wb-panel__seg';
